module.exports = "./img/97420e3f96e688876cd22bb1cfd3922d.jpg";